<template>
	<div class="nfl-week-update-page">
		<div class="nfl-week-update-page__content">
			<div class="games" v-if="games.length > 0">
				<h1>Week {{ week.week_number }}</h1>
				<div class="game" v-for="(game, index) in week.games" :key="game.id">
					<div class="away-team">
						<p>{{ game.away_team.nickname }}</p>
						<input type="number" v-model="games[index][0].away_team.score">
					</div>
					<div class="home-team">
						<p>{{ game.home_team.nickname }}</p>
						<input type="number" v-model="games[index][0].home_team.score">
					</div>
					<div class="time">
						<p>Date-Time</p>
						<input type="text" v-model="games[index][0].date_time">
					</div>
					<div class="underway">
						<p>Underway</p>
						<input type="checkbox" v-model="games[index][0].underway">
					</div>
					<div class="finished">
						<p>Finished</p>
						<input type="checkbox" v-model="games[index][0].finished">
					</div>
					<button @click="updateGame(game.id)">Update</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapMutations } from 'vuex'
	import axios from '@/axios'

	export default {
		props: [ 'seasonId', 'weekId' ],
		data() {
			return {
				week: null,
				games: []
			}
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED'
			]),
			updateGame(gameId) {
				var game
				this.games.forEach((element) => {
					if (element[0].id == gameId) {

						game = {
							underway: element[0].underway ? 1 : 0,
							finished: element[0].finished ? 1 : 0,
							date_time: element[0].date_time,
							home_participant_score: parseInt(element[0].home_team.score, 10),
							away_participant_score: parseInt(element[0].away_team.score, 10),

						}
					}
				})

				this.HTTP_IN_PROGRESS()
				axios.patch('nfl-seasons/' + this.seasonId + '/nfl-weeks/' + this.weekId + '/nfl-regular-season-games/' + gameId, game).then(() => {
					this.getNflWeek().then(() => {
						this.HTTP_FINISHED()
					})
				})
			},
			getNflWeek() {
				return axios.get('nfl-seasons/' + this.seasonId + '/nfl-weeks/' + this.weekId).then((response) => {
					this.week = response.data.data
					this.week.games.forEach((game, index) => {
						this.games.splice(index, 1, [ game])
					})
				})
			},
		},
		created() {
			this.HTTP_IN_PROGRESS()
			this.getNflWeek().then(() => {
				this.HTTP_FINISHED()
			}).catch(() => {
				this.HTTP_FINISHED()
				this.$router.replace('/')
			})
		},
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../../styles/views/admin/nfl/nfl-week/update';
</style>